export type OssProvider = 'obs' | 'aliyun';
// type OssPerm = 'public' | 'private';
export type OssConfig = {
  ossProvider: OssProvider;
  bucketName: string;
};

/**
 * DO_NOT_MANUALLY_MODIFY
 * 1. 由 provider 决定走哪一个云存储（阿里云 || 平安云）
 * 2. private bucket 服务端做302跳转，public bucket 客户端直接访问，所以有不同的路径拼法
 * 3. *特例*是全局 provider 是阿里云的时候，还是有部分 pu blic 资源放在平安云上
 *
 * @param {string} url 相对路径
 */
export function getOssUrl(
  urlSuffix: string,
  conf: OssConfig & {
    host: string;
  },
) {
  const { bucketName, host, ossProvider } = conf;
  return `https://${bucketName}.${ossProvider}.${host}/${urlSuffix}`;
}

export function resizeImage(url: string, width: number, height: number): string {
  return `${url}?x-oss-process=image/resize,m_lfit,w_${width},h_${height}`;
}
